import useInfiniteScrollApolloQuery from '@hooks/useInfiniteScroll/useInfiniteScrollApolloQuery';
import { useContext, useEffect, useState } from 'react';
import { isbot } from 'isbot';
import AVAILABLE_DESIGNERS_QUERY, {
  Designer,
  INTERIOR_DESIGNER_PAGE_SIZE
} from '@graphql/Designer/queries/availableDesigners.graphql';
import useIsHighValueCustomer from '@hooks/User/useIsHighValueCustomer';
import UserContext from '@context/User/user-context';

let maxAmountOfPages: number;

export default function useInteriorDesigners(
  styleIds: number[],
  roomTypeIds: number[],
  initialDesigners: Designer[]
) {
  useEffect(() => {
    const isBot = isbot(navigator.userAgent);
    if (isBot) {
      maxAmountOfPages = 4;
    }
  }, []);

  const { user } = useContext(UserContext);
  const { isHighValueCustomer } = useIsHighValueCustomer(user);

  const {
    data,
    error,
    loading = false,
    loadingMore,
    reset,
    resetting,
  } = useInfiniteScrollApolloQuery({
    query: AVAILABLE_DESIGNERS_QUERY,
    variables: {
      filters: {
        styleIds,
        roomTypeIds,
      },
      isHvc: isHighValueCustomer
    },
    dataResultsKey: 'availableDesigners',
    targetScrollOffset: 2400,
    maxAmountOfPages
  }, {
    pageSize: INTERIOR_DESIGNER_PAGE_SIZE,
  });

  const [designers, setDesigners] = useState(initialDesigners);
  useEffect(() => {
    if (data && data.availableDesigners && data.availableDesigners.items) {
      setDesigners(data.availableDesigners.items);
    }
  }, [data]);

  return {
    designers,
    error,
    loading: loading && initialDesigners.length === 0,
    loadingMore,
    reset,
    resetting,
  };
}
